import { getFollowSellerAnalytics, getUnfollowSellerAnalytics } from './analytics';
import { LOAD_BIDDER_DATA_SUCCESS, LOG_OUT_BIDDER, LOGIN_SUCCESS } from './actions';
import api from '@/redux/api/seller';
import { createSelector } from '@reduxjs/toolkit';
import difference from 'lodash/difference';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { PASSWORD_RESET_SUCCESS } from './passwordReset';
import union from 'lodash/union';

/* Action Types */
export const FOLLOW_SELLER_FAIL = 'la/user/followSeller/FAIL';
export const FOLLOW_SELLER_REQUEST = 'la/user/followSeller/REQUEST';
export const FOLLOW_SELLER_SUCCESS = 'la/user/followSeller/SUCCESS';

export const UNFOLLOW_SELLER_FAIL = 'la/user/unfollowSeller/FAIL';
export const UNFOLLOW_SELLER_REQUEST = 'la/user/unfollowSeller/REQUEST';
export const UNFOLLOW_SELLER_SUCCESS = 'la/user/unfollowSeller/SUCCESS';

// reducer
export const DEFAULT_STATE = [];

export type State = number[];

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case FOLLOW_SELLER_SUCCESS:
            return union(state, [action.payload]);

        case LOG_OUT_BIDDER:
            return [];

        case LOAD_BIDDER_DATA_SUCCESS:
        case LOGIN_SUCCESS:
        case PASSWORD_RESET_SUCCESS:
            return [...action.payload.followedSellers];

        case UNFOLLOW_SELLER_SUCCESS:
            return difference(state, [action.payload]);

        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.followSeller;
const idSelector = (state: GlobalState, id) => id;

export const getFollowedSellerIds = createSelector(stateSelector, (state) => [...state]);

export const isSellerFollowed: (arg0: any, arg1: number) => boolean = createSelector(
    [stateSelector, idSelector],
    (state, id) => state.indexOf(id) >= 0
);

/* ACTION CREATORS */
export const submitFollowSeller = (sellerId: number) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: FOLLOW_SELLER_REQUEST,
        });

        await api.postFollow({ authToken, deployment, sellerId });
        return dispatch({
            meta: getFollowSellerAnalytics(state, sellerId),
            payload: sellerId,
            type: FOLLOW_SELLER_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: FOLLOW_SELLER_FAIL,
        });
    }
};

export const submitUnfollowSeller = (sellerId: number) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: UNFOLLOW_SELLER_REQUEST,
        });
        await api.postUnfollow({ authToken, deployment, sellerId });
        dispatch({
            meta: getUnfollowSellerAnalytics(state, sellerId),
            payload: sellerId,
            type: UNFOLLOW_SELLER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: UNFOLLOW_SELLER_FAIL,
        });
    }
};
